import { defineMobileFormWindow } from "@app/overlay";
import {
    StockKanbanSupplyFilterForm,
    type StockKanbanSupplyFilterFormProps,
} from "./components/StockKanbanSupplyFilter/StockKanbanSupplyFilterForm";

/** Реестр overlay-окон списка контейнеров КАНБАН. */
export const stockKanbanSupplyListWindows = {
    filter: defineMobileFormWindow<StockKanbanSupplyFilterFormProps>({
        key: "stock.kanbanSupply.filter",
        title: "Фильтр контейнеров КАНБАН",
        component: StockKanbanSupplyFilterForm,
    }),
};
